import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITutorial, IUpdateTutorialSeenPayload, TTutorialsError } from "./tutorials.t";
import _ from "lodash";
import { LOGOUT_SUCCESS } from "../Login/loginConstants";

export interface ITutorialsState {
    isFirstShowIntro: boolean;
    isInited: boolean;
    isShowBeginnersGuideInvite: boolean;
    isShowWatchMoreVideosLaterTooltip: boolean;
    isTutorialsLoading: boolean;
    tutorialsError: TTutorialsError;
    tutorialsList: ITutorial[];
}

const initialState: ITutorialsState = {
    isFirstShowIntro: false,
    isInited: false,
    isShowBeginnersGuideInvite: false,
    isShowWatchMoreVideosLaterTooltip: false,
    isTutorialsLoading: false,
    tutorialsError: null,
    tutorialsList: [],
}

export const tutorialsSlice = createSlice({
    name: 'tutorials',
    initialState,
    reducers: {
        initTutorialsAction(state, action: PayloadAction) {},

        loadTutorialsListAction(state, action: PayloadAction) {
            state.isTutorialsLoading = true;
        },
        loadTutorialsListSuccess(state, action: PayloadAction<ITutorial[]>) {
            state.tutorialsList = action.payload;
            state.isTutorialsLoading = false;
        },
        loadTutorialsListFailure(state, action: PayloadAction<TTutorialsError>) {
            state.isTutorialsLoading = false;
            state.tutorialsError = action.payload;
        },

        updateTutorialSeenAction(state, action: PayloadAction<IUpdateTutorialSeenPayload>) {},
        updateTutorialSeenFailure(state, action: PayloadAction<TTutorialsError>) {
            state.tutorialsError = action.payload;
        },

        showWatchMoreVideosLaterTooltipAction(state, action) {
            state.isShowWatchMoreVideosLaterTooltip = action.payload;
        },
        setIsFirstShowIntroAction(state, action) {
            state.isFirstShowIntro = action.payload;
        },

        setIsTutorialsInitedAction(state, action: PayloadAction<boolean>) {
            state.isInited = action.payload;
        },

        updateTutorialItemAction(state, action: PayloadAction<Partial<ITutorial>>) {
            const tutorialUpdateIndex = _.findIndex(state.tutorialsList, { name: action.payload.name });
            const currentTutorial = state.tutorialsList[tutorialUpdateIndex];
            state.tutorialsList.splice(tutorialUpdateIndex, 1, { ...currentTutorial, ...action.payload });
        },
        deleteTutorialItemAction(state, action: PayloadAction<ITutorial['name']>) {
            state.tutorialsList = _.filter(state.tutorialsList, (tutorial) => tutorial.name !== action.payload);
        },
        setIsShowBeginnersGuideInviteAction(state, action: PayloadAction<boolean>) {
            state.isShowBeginnersGuideInvite = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(LOGOUT_SUCCESS, (state) => {
            return {
                ...initialState,
            }
        })
    },
});

export const {
    deleteTutorialItemAction,
    initTutorialsAction,
    loadTutorialsListAction,
    loadTutorialsListFailure,
    loadTutorialsListSuccess,
    setIsFirstShowIntroAction,
    setIsTutorialsInitedAction,
    showWatchMoreVideosLaterTooltipAction,
    updateTutorialItemAction,
    updateTutorialSeenAction,
    updateTutorialSeenFailure,
} = tutorialsSlice.actions;

export default tutorialsSlice.reducer;

